var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Map(el) {
	var $el = $(el),
		$pins = $('svg [id^="pin_"]');

	$el.on('hover', 'svg a', function(e) {
		var id = $(this).attr('id'),
			$pin = $pins.filter('[id*="_' + id + '_"]');

		$pin.toggleClass('highlighted-pin', e.type == 'mouseenter');
	});
}

module.exports = Map;
